(function() { window.GUID_8ed4659f_dd6b_44a0_adb3_f6b21e8caa0e = { getGuid: function() { return "8ed4659f-dd6b-44a0-adb3-f6b21e8caa0e"; } }; })();
//namespace CS.Controls {
//    export class SportEvent extends ControlBase {
//        private $control: JQuery;
//        private controlId: string;
//        public get ControlId(): string {
//            return this.controlId;
//        }
//        public get $Control(): JQuery {
//            return this.$control;
//        }
//        protected OnControlInstantiation(params: any[]) {
//            this.controlId = params[0];
//            this.$control = $('#' + params[0]);//contient le Id
//        }
//        public OnDispose() {
//            this.$control.off('click.' + this.UniqueNamespace);
//            this.$control.remove();
//        }
//        public OnBindEvents() {
//            let me = this;
//            me.$Control.on('click.' + this.UniqueNamespace, 'tr', function (e) {
//                let $this = $(this);
//                if ($this.hasClass('see-more-rows')) {
//                    me.Trigger<SportEvent.ISeeMoreClickedEventArgs>(SportEvent.EventNames.SeeMoreClicked, { jqueryEventObject: e, data: { takemax: $this.data('takemax') } });
//                    //me.RaiseEvent(SportEventEvents.SeeMoreClicked, e, $this.data('takemax'));
//                }
//                else {
//                    let href = $(this).data('href');
//                    if (href != null) {
//                        CS.Nav.Go(href);
//                    }
//                }
//            });
//        }
//        OnControlInstantiated() {
//        }
//    }
//    export namespace SportEvent {
//        export class Events {
//            public static SeeMoreClicked(param: IEvent<SportEvent, ISeeMoreClickedEventArgs>) {
//                RegisterEvent(SportEvent, EventNames.SeeMoreClicked, param);
//            }
//        }
//        export class EventNames {
//            public static SeeMoreClicked = "see-more-clicked";
//        }
//        export interface ISeeMoreClickedEventArgs {
//            takemax: number;
//        }
//    }
//}

//# sourceMappingURL=sportevent.js.map
